// @flow
import * as React from "react";

import AffiliateBalance from "./AffiliateBalance";
import SearchBar from "./SearchBar";
import ThemeToggle from "./ThemeToggle";
import UserMenu from "./UserMenu";

type Props = {
  children: React.Node,
  themeFirst?: boolean,
};

function List({ children, themeFirst = false }: Props): React.Node {
  return (
    <ul className="navbar-nav ms-auto align-items-center">
      {themeFirst && <ThemeToggle />}
      {children}
      {!themeFirst && <ThemeToggle />}
      <UserMenu />
    </ul>
  );
}

function Manager(): React.Node {
  return (
    <List>
      <li className="nav-item">
        <SearchBar />
      </li>
    </List>
  );
}

function Affiliate(): React.Node {
  return (
    <List themeFirst>
      <AffiliateBalance />
    </List>
  );
}

export default {
  Manager,
  Affiliate,
};
